import "@/App.css";
import { Loader2 } from "lucide-react";
import { ThemeProvider } from "@/lib/theme";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Launcher from "@/pages/Launcher";
import Login from "@/pages/Login";

function Gate() {
  const { user, ready } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return user ? <Launcher /> : <Login />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <Gate />
          <Toaster position="bottom-right" richColors />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
